import { render, staticRenderFns } from "./ODateTime.vue?vue&type=template&id=710ee2a2&scoped=true"
import script from "./ODateTime.vue?vue&type=script&lang=js"
export * from "./ODateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ee2a2",
  null
  
)

export default component.exports